import React, { useState, useEffect } from "react";
import Button from "../components/Buttons/Button";
import Swal from "sweetalert2";
import Loader from "../components/Loader";
import Datatable from "../components/tables/Datatable";

const columns = [
  {
    header: "ID",
    accessor: "id",
  },
  {
    header: "Category Name",
    accessor: "cat_name",
  },
];

const AddMealCat = () => {
  const [initialLoad, setInitialLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [addategory, setAddategory] = useState("");
  const [error, setError] = useState("");

  // 🔥 pagination state
  const [page, setPage] = useState(1);
  const [entries, setEntries] = useState(5);

  // 🔥 Initial loader for page refresh / first load
  useEffect(() => {
    const timer = setTimeout(() => setInitialLoad(false), 500);
    return () => clearTimeout(timer);
  }, []);

  // 🚀 Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!addategory.trim()) {
      setError("Meal Category name is required");
      return;
    }

    try {
      setLoading(true); // start submit spinner

      await Swal.fire({
        title: "Success!",
        text: "New Category Added!",
        icon: "success",
      });

      setAddategory("");
    } finally {
      setLoading(false); // stop submit spinner
    }
  };

  const staticCategories = [
    { id: 1, cat_name: "Curries" },
    { id: 2, cat_name: "Vegetarian Dish" },
    { id: 3, cat_name: "Drinks" },
    { id: 4, cat_name: "Desserts" },
    { id: 5, cat_name: "Bread" },
  ];

  const totalPages = Math.ceil(staticCategories.length / entries);

  const paginatedData = staticCategories.slice(
    (page - 1) * entries,
    page * entries,
  );
  // 🌟 SHOW LOADER BEFORE ANYTHING RENDERS
  if (initialLoad) return <Loader />;

  return (
    <section className="mx-auto px-4 bg-gray-50">
      <div className="w-full max-w-7xl bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-gray-900">
            Add Meal Category
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            Provide details to create a new meal category.
          </p>
        </div>

        <form className="space-y-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end">
            <div className="flex flex-col flex-1">
              <label
                htmlFor="Addategory"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                Category Name
              </label>

              <input
                id="Addategory"
                type="text"
                value={addategory}
                onChange={(e) => {
                  setAddategory(e.target.value);
                  if (error) setError("");
                }}
                placeholder="Type Category name..."
                className={`w-full rounded-lg px-4 py-3 border ${
                  error
                    ? "border-red-500"
                    : addategory.trim()
                      ? "border-green-500"
                      : "border-gray-300"
                }`}
              />
            </div>

            <Button
              text={loading ? "Saving..." : "Add Category"}
              disabled={loading}
              classes="w-full sm:w-[180px] md:w-[300px] py-3"
              onClick={handleSubmit}
            />
          </div>
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </form>
      </div>
      <div className="w-full max-w-7xl bg-white rounded-2xl border border-gray-200 shadow-sm p-8 mt-12">
        <Datatable
          title="Category List"
          columns={columns}
          data={paginatedData}
          isloading={false}
          paginationInfo={{
            currentPage: page,
            totalPages: totalPages,
            entriesPerPage: entries,
            onPageChange: (p) => setPage(p),
            onEntriesChange: (val) => {
              setEntries(val);
              setPage(1);
            },
          }}
        />
      </div>
    </section>
  );
};

export default AddMealCat;
